import React from "react"

import { ImageSet } from "../../common/image-set/ImageSet"
import PaymentCard from "../../../assets/images/payment-cards-banner.png"
import PaymentCard2X from "../../../assets/images/payment-cards-banner@2x.png"

import * as s from "./PaymentBanner.module.scss"

export const PaymentBanner = () => {
  return (
    <div className={s.paymentBanner}>
      <ImageSet
        className={s.paymentBanner__image}
        oneX={PaymentCard}
        twoX={PaymentCard2X}
        alt="Payment methods which we accept at this time."
      />
    </div>
  )
}
